import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
	callGetAllMember, callDeleteMemberById, callGetMemberById, callFindMember,
	callEditMember, callChangePassword, callGetDeviceNotification, callAddDeviceNotification,
	callDeleteDeviceNotification, callDashboard
} from "../api/users/service";

const userSlice = createSlice({
	name: 'userData',
	initialState: {
		data: null,
		isLoading: true,
		error: null,
	},
	reducers: {
		setData: (state, { payload }) => {
			state.data = payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(callEditMember.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callEditMember.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callEditMember.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callGetAllMember.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetAllMember.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callGetAllMember.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callGetMemberById.pending, (state) => {
				state.isLoading = true;
				state.memberItem = null;
			})
			.addCase(callGetMemberById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				} else {
					state.memberItem = action.payload;
				}
			})
			.addCase(callGetMemberById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				state.memberItem = null;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callDeleteMemberById.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callDeleteMemberById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				}
			})
			.addCase(callDeleteMemberById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callFindMember.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callFindMember.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callFindMember.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})

			.addCase(callChangePassword.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callChangePassword.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				}
			})
			.addCase(callChangePassword.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callGetDeviceNotification.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetDeviceNotification.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				}
				state.deviceNotification = action.payload
			})
			.addCase(callGetDeviceNotification.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callAddDeviceNotification.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callAddDeviceNotification.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				}
			})
			.addCase(callAddDeviceNotification.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callDeleteDeviceNotification.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callDeleteDeviceNotification.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				}
			})
			.addCase(callDeleteDeviceNotification.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
	},
});
export const { setData } = userSlice.actions;
export default userSlice.reducer;
